function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { context, updateContextState } from "../../components/wr-context";
import { requests as productRequests } from "../product";
import { uniqueArrayById } from "../../utils/array";
import { dedupeCategories } from "../../utils/categories";
var transformBundle = function(bundle) {
    var ref;
    var pointSystem = context.state.pointSystem;
    var priceLabel = pointSystem ? bundle.settings.displayText : bundle.settings.cost || "0";
    var priceValue = priceLabel ? priceLabel.replace(/\D+/g, "") : 0;
    if (!bundle.categories && !((ref = bundle.categories) === null || ref === void 0 ? void 0 : ref.length)) {
        bundle.categories = [
            {
                id: "category-undefined",
                value: "category-undefined",
                label: "Other Products",
                name: "Other Products",
                pos: Number.POSITIVE_INFINITY
            }, 
        ];
    }
    bundle.pricing = {
        label: priceLabel,
        value: priceValue
    };
    return bundle;
};
var retrieveCategoriesAndFilters = function(bundles) {
    var categories = [];
    bundles.forEach(function(bundle) {
        var ref;
        (ref = bundle.categories) === null || ref === void 0 ? void 0 : ref.forEach(function(category) {
            category.label = category.name;
            category.value = category.id;
            categories.push(category);
            if (category.parentCategoryId) {
                categories.push({
                    name: category.parentName,
                    id: category.parentCategoryId,
                    label: category.parentName,
                    value: category.parentCategoryId
                });
            }
        });
    });
    return {
        categories: uniqueArrayById(categories)
    };
};
var fetchBundles = function(param) {
    var _getAllBundles = param.getAllBundles, getAllBundles = _getAllBundles === void 0 ? false : _getAllBundles, catalogId = param.catalogId;
    return {
        url: "".concat(context.constants.appHost, "/api/v1/service-catalogs/catalogs/catalog-id/").concat(catalogId || context.constants.client.catalogIds[0], "/product-bundles"),
        comparison: catalogId || context.constants.client.companyId,
        method: "GET",
        then: function(param) {
            var catalogBundles = param.data;
            return {
                url: "".concat(context.constants.appHost, "/api/v2/groups/search?groupType=bundle&shouldFetchGroupCategories=true&companyId=").concat(context.constants.client.companyId),
                comparison: context.constants.client.companyId,
                method: "GET",
                then: function(param) {
                    var bundles = param.data;
                    var bundlesToDisplay = [];
                    catalogBundles.forEach(function(bundle) {
                        bundlesToDisplay.push(bundles.find(function(b) {
                            return b.id === bundle.groupId;
                        }));
                    });
                    var categories = retrieveCategoriesAndFilters(bundles).categories;
                    if (getAllBundles) {
                        bundlesToDisplay = bundles;
                    }
                    updateContextState(function(state) {
                        state.bundles = bundlesToDisplay.map(function(bundle) {
                            return transformBundle(bundle);
                        });
                        state.categories = dedupeCategories(_toConsumableArray(state.categories).concat(_toConsumableArray(categories)));
                    });
                    return {
                        value: bundlesToDisplay
                    };
                }
            };
        }
    };
};
var fetchBundleById = function(bundleId) {
    return {
        url: "".concat(context.constants.appHost, "/api/v2/groups/").concat(bundleId, "/members"),
        method: "GET",
        comparison: bundleId,
        andThen: function(param) {
            var members = param.data;
            var bundleMembers = members.map(function(member) {
                return member.childId;
            });
            var queuedRequests = {};
            bundleMembers.forEach(function(member, index) {
                queuedRequests["productFetch".concat(index)] = productRequests.fetchProductById(member);
            });
            return _objectSpread({}, queuedRequests);
        }
    };
};
var bundleRequests = {
    fetchBundles: fetchBundles,
    fetchBundleById: fetchBundleById
};
export default bundleRequests;
